import * as dayjs from "dayjs";

export interface IFilter {
  name: string;
  type: string;
  options?: any[];
  unremovable?: boolean;
  unit?: string;
  default?: any;
  dropdownType?: string;
}

export enum FilterType {
  TEXT = 'text',
  DATE = 'date',
  DATE_TIME = 'datetime',
  DROPDOWN = 'dropdown',
  DID = 'did',
  USER = 'user',
  INTERVAL = 'interval',
  TIMEZONE = 'timezone',
  TAGS = 'tag_ids'
}

export enum CallStatus {
  answered = 'ANSWERED',
  unanswered = 'UNANSWERED'
}

export enum CallType {
  phone_call = 'PHONE_CALL',
  click_to_call = 'CLICK_TO_CALL',
  fax_call = 'FAX_CALL',
  whatsapp = 'WHATSAPP'
}

export enum CallDirection {
  inbound = 'INBOUND',
  outbound = 'OUTBOUND',
  internal = 'INTERNAL'
}

export enum FilterBoolean {
  yes = 'yes',
  no = 'no'
}

export interface IInterval {
  from: number;
  to: number;
}

export interface IDateTime {
  from: string;
  from_time: string;
  to: string;
  to_time: string;
}

export const defaultUsedFilters: IFilter[] = [
  {
    name: 'date_time_ranges',
    type: FilterType.DATE_TIME,
    unremovable: true,
    default: [
      {
        from: dayjs().subtract(1, 'month').toISOString(),
        to: new Date().toISOString(),
        from_time: '00:00',
        to_time: '23:59'
      }
    ]
  },
  {
    name: 'timezone',
    type: FilterType.TIMEZONE,
    unremovable: true
  }
]

export const filters: IFilter[] = [
  {
    name: 'did_number',
    type: FilterType.DID
  },
  {
    name: 'is_answered',
    type: FilterType.DROPDOWN,
    options: [
      CallStatus.answered,
      CallStatus.unanswered
    ],
    dropdownType: 'call_status'
  },
  {
    name: 'directions',
    type: FilterType.DROPDOWN,
    options: [
      CallDirection.inbound,
      CallDirection.outbound,
      CallDirection.internal
    ]
  },
  {
    name: 'event_types',
    type: FilterType.DROPDOWN,
    options: [
      CallType.phone_call,
      CallType.click_to_call,
      CallType.fax_call,
      CallType.whatsapp
    ]
  },
  {
    name: 'duration',
    type: FilterType.INTERVAL,
    unit: 'minutes'
  },
  {
    name: 'ring_time',
    type: FilterType.INTERVAL,
    unit: 'seconds'
  },
  {
    name: 'sentiment_score',
    type: FilterType.INTERVAL
  },
  {
    name: 'destination_name',
    type: FilterType.TEXT
  },
  {
    name: 'destination_number',
    type: FilterType.TEXT
  },
  {
    name: 'originator_name',
    type: FilterType.TEXT
  },
  {
    name: 'originator_number',
    type: FilterType.TEXT
  },
  {
    name: 'answerer_name',
    type: FilterType.TEXT
  },
  {
    name: 'answerer_number',
    type: FilterType.TEXT
  },
  {
    name: 'voicemail',
    type: FilterType.DROPDOWN,
    options: [
      FilterBoolean.yes,
      FilterBoolean.no
    ],
    dropdownType: 'boolean'
  },
  {
    name: 'with_sms',
    type: FilterType.DROPDOWN,
    options: [
      FilterBoolean.yes,
      FilterBoolean.no
    ],
    dropdownType: 'boolean'
  },
  {
    name: 'recorded',
    type: FilterType.DROPDOWN,
    options: [
      FilterBoolean.yes,
      FilterBoolean.no
    ],
    dropdownType: 'boolean'
  },
  {
    name: 'user_id',
    type: FilterType.USER
  },
  {
    name: 'tag_ids',
    type: FilterType.TAGS
  }
];